<template>
  <!--
    Knappen har kun et ikon. Uden et tilgængeligt navn kan hverken en
    skærmlæser, en tastaturbruger eller en test finde ud af hvad den gør, og
    en mus skal gætte sig frem.
  -->
  <button
    type="button"
    class="btn btn-outline-primary btn-price-alert"
    :title="etiket"
    :aria-label="etiket"
    :aria-pressed="hasAlert"
    @click="emitOpen"
  >
    <i class="bi" :class="hasAlert ? 'bi-bell-fill' : 'bi-bell'" aria-hidden="true"></i>
    <span class="visually-hidden">{{ etiket }}</span>
  </button>
</template>

<script>
export default {
  name: 'PriceAlertButton',
  props: {
    hasAlert: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    etiket() {
      return this.hasAlert ? 'Redigér din prisalarm' : 'Opret prisalarm';
    }
  },
  methods: {
    emitOpen() {
      this.$emit('open-modal');
    }
  }
}
</script>

<style scoped>
.btn-price-alert {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background-color: transparent;
  color: var(--pc-text-secondary, #adb5bd);
  border: 1px solid var(--pc-border, rgba(255, 255, 255, 0.15));
  transition: all 0.2s ease;
  padding: 0;
}

.btn-price-alert:hover {
  background-color: rgba(0, 201, 167, 0.1);
  color: var(--pc-primary, #00c9a7);
  border-color: var(--pc-primary, #00c9a7);
  transform: translateY(-1px);
}

.btn-price-alert i {
  font-size: 1rem;
}
</style>
